import BagIllustration from '@/assets/illustrations/bag.svg';
import BoxErrorIllustration from '@/assets/illustrations/box-error.svg';
import BoxIllustration from '@/assets/illustrations/box.svg';
import FlagBrIllustration from '@/assets/illustrations/flag-br.svg';
import FlagDeIllustration from '@/assets/illustrations/flag-de.svg';
import FlagDkIllustration from '@/assets/illustrations/flag-dk.svg';
import FlagEsIllustration from '@/assets/illustrations/flag-es.svg';
import FlagFiIllustration from '@/assets/illustrations/flag-fi.svg';
import FlagFrIllustration from '@/assets/illustrations/flag-fr.svg';
import FlagNoIllustration from '@/assets/illustrations/flag-no.svg';
import FlagSeIllustration from '@/assets/illustrations/flag-se.svg';
import FlagUsIllustration from '@/assets/illustrations/flag-us.svg';
import LogoSimpelLockupBlackIllustration from '@/assets/illustrations/logo-simpel-lockup-black.svg';
import LogoSimpelLockupBrandIllustration from '@/assets/illustrations/logo-simpel-lockup-brand.svg';
import LogoSimpelLockupWhiteIllustration from '@/assets/illustrations/logo-simpel-lockup-white.svg';
import LogoSimpelSymbolBlackIllustration from '@/assets/illustrations/logo-simpel-symbol-black.svg';
import LogoSimpelSymbolBoxBrandReverseIllustration from '@/assets/illustrations/logo-simpel-symbol-box-brand-reverse.svg';
import LogoSimpelSymbolBoxBrandIllustration from '@/assets/illustrations/logo-simpel-symbol-box-brand.svg';
import LogoSimpelSymbolBoxDarkIllustration from '@/assets/illustrations/logo-simpel-symbol-box-dark.svg';
import LogoSimpelSymbolBoxWhiteIllustration from '@/assets/illustrations/logo-simpel-symbol-box-white.svg';
import LogoSimpelSymbolBrandIllustration from '@/assets/illustrations/logo-simpel-symbol-brand.svg';
import LogoSimpelSymbolWhiteIllustration from '@/assets/illustrations/logo-simpel-symbol-white.svg';
import LogoSimpelWordmarkBlackIllustration from '@/assets/illustrations/logo-simpel-wordmark-black.svg';
import LogoSimpelWordmarkBrandIllustration from '@/assets/illustrations/logo-simpel-wordmark-brand.svg';
import LogoSimpelWordmarkWhiteIllustration from '@/assets/illustrations/logo-simpel-wordmark-white.svg';
import MeasureIllustration from '@/assets/illustrations/measure.svg';
import PackageIllustration from '@/assets/illustrations/package.svg';
import PackageSecondIllustration from '@/assets/illustrations/package-second.svg';
import PackageThirdIllustration from '@/assets/illustrations/package-third.svg';
import PalletIllustration from '@/assets/illustrations/pallet.svg';
import PoweredByGoogle from '@/assets/illustrations/powered-by-google.svg';
import SimpelTruckIllustration from '@/assets/illustrations/simpel_truck.svg';
import SimpelTruckReady from '@/assets/illustrations/simpel-truck-ready.svg';
import SimpelTruckSuccess from '@/assets/illustrations/simpel-truck-success.svg';
import SimpelTruckRunningIllustration from '@/assets/illustrations/simpel_truck_running.svg';
import SimpelTruckRunningPallet1Illustration from '@/assets/illustrations/simpel_truck_running_pallet-1.svg';
import SimpelTruckRunningPallet2Illustration from '@/assets/illustrations/simpel_truck_running_pallet-2.svg';
import SimpelTruckRunningPalletErrorIllustration from '@/assets/illustrations/simpel_truck_running_pallet_error.svg';
import SimpelTruckRunningPalletSuccessIllustration from '@/assets/illustrations/simpel_truck_running_pallet_success.svg';
import SymbolMonoIllustration from '@/assets/illustrations/symbol-mono.svg';
import SymbolIllustration from '@/assets/illustrations/symbol.svg';
import WordmarkDarkIllustration from '@/assets/illustrations/wordmark-dark.svg';
import WordmarkLightIllustration from '@/assets/illustrations/wordmark-light.svg';
import WordmarkSymbolTaglineBoDarkIllustration from '@/assets/illustrations/wordmark-symbol-tagline-bo-dark.svg';
import WordmarkSymbolTaglineHorizontalDarkIllustration from '@/assets/illustrations/wordmark-symbol-tagline-horizontal-dark.svg';
import WordmarkSymbolHorizontalDarkIllustration from '@/assets/illustrations/wordmark-symbol-horizontal-dark.svg';
import WordmarkSymbolHorizontalLightIllustration from '@/assets/illustrations/wordmark-symbol-horizontal-light.svg';
import WordmarkSymbolTaglineHorizontalMonoIllustration from '@/assets/illustrations/wordmark-symbol-tagline-horizontal-mono.svg';
import WordmarkSymbolTaglineVerticalDarkIllustration from '@/assets/illustrations/wordmark-symbol-tagline-vertical-dark.svg';
import WordmarkSymbolTaglineVerticalLightIllustration from '@/assets/illustrations/wordmark-symbol-tagline-vertical-light.svg';
import WordmarkSymbolTaglineVerticalMonoIllustration from '@/assets/illustrations/wordmark-symbol-tagline-vertical-mono.svg';
import WordmarkSymbolVerticalDarkIllustration from '@/assets/illustrations/wordmark-symbol-vertical-dark.svg';
import WordmarkSymbolVerticalLightIllustration from '@/assets/illustrations/wordmark-symbol-vertical-light.svg';
import WordmarkTaglineBoDarkIllustration from '@/assets/illustrations/wordmark-tagline-bo-dark.svg';
import WordmarkTaglineDarkIllustration from '@/assets/illustrations/wordmark-tagline-dark.svg';
import WordmarkTaglineLightIllustration from '@/assets/illustrations/wordmark-tagline-light.svg';

export const illustrations = {
    bag: BagIllustration,
    boxError: BoxErrorIllustration,
    box: BoxIllustration,
    flagBr: FlagBrIllustration,
    flagDe: FlagDeIllustration,
    flagDk: FlagDkIllustration,
    flagEs: FlagEsIllustration,
    flagFi: FlagFiIllustration,
    flagFr: FlagFrIllustration,
    flagNo: FlagNoIllustration,
    flagSe: FlagSeIllustration,
    flagUs: FlagUsIllustration,
    logoSimpelLockupBlack: LogoSimpelLockupBlackIllustration,
    logoSimpelLockupBrand: LogoSimpelLockupBrandIllustration,
    logoSimpelLockupWhite: LogoSimpelLockupWhiteIllustration,
    logoSimpelSymbolBlack: LogoSimpelSymbolBlackIllustration,
    logoSimpelSymbolBoxBrandReverse:
        LogoSimpelSymbolBoxBrandReverseIllustration,
    logoSimpelSymbolBoxBrand: LogoSimpelSymbolBoxBrandIllustration,
    logoSimpelSymbolBoxDark: LogoSimpelSymbolBoxDarkIllustration,
    logoSimpelSymbolBoxWhite: LogoSimpelSymbolBoxWhiteIllustration,
    logoSimpelSymbolBrand: LogoSimpelSymbolBrandIllustration,
    logoSimpelSymbolWhite: LogoSimpelSymbolWhiteIllustration,
    logoSimpelWordmarkBlack: LogoSimpelWordmarkBlackIllustration,
    logoSimpelWordmarkBrand: LogoSimpelWordmarkBrandIllustration,
    logoSimpelWordmarkWhite: LogoSimpelWordmarkWhiteIllustration,
    measure: MeasureIllustration,
    package: PackageIllustration,
    packageSecond: PackageSecondIllustration,
    packageThird: PackageThirdIllustration,
    pallet: PalletIllustration,
    poweredByGoogle: PoweredByGoogle,
    simpelTruck: SimpelTruckIllustration,
    simpelTruckSuccess: SimpelTruckSuccess,
    simpelTruckReady: SimpelTruckReady,
    simpelTruckRunning: SimpelTruckRunningIllustration,
    simpelTruckRunningPallet1: SimpelTruckRunningPallet1Illustration,
    simpelTruckRunningPallet2: SimpelTruckRunningPallet2Illustration,
    simpelTruckRunningPalletError: SimpelTruckRunningPalletErrorIllustration,
    simpelTruckRunningPalletSuccess:
        SimpelTruckRunningPalletSuccessIllustration,
    symbolMono: SymbolMonoIllustration,
    symbol: SymbolIllustration,
    wordmarkDark: WordmarkDarkIllustration,
    wordmarkLight: WordmarkLightIllustration,
    wordmarkSymbolTaglineBoDark: WordmarkSymbolTaglineBoDarkIllustration,
    wordmarkSymbolTaglineHorizontalDark:
        WordmarkSymbolTaglineHorizontalDarkIllustration,
    wordmarkSymbolHorizontalDark: WordmarkSymbolHorizontalDarkIllustration,
    wordmarkSymbolHorizontalLight: WordmarkSymbolHorizontalLightIllustration,
    wordmarkSymbolTaglineHorizontalMono:
        WordmarkSymbolTaglineHorizontalMonoIllustration,
    wordmarkSymbolTaglineVerticalDark:
        WordmarkSymbolTaglineVerticalDarkIllustration,
    wordmarkSymbolTaglineVerticalLight:
        WordmarkSymbolTaglineVerticalLightIllustration,
    wordmarkSymbolTaglineVerticalMono:
        WordmarkSymbolTaglineVerticalMonoIllustration,
    wordmarkSymbolVerticalDark: WordmarkSymbolVerticalDarkIllustration,
    wordmarkSymbolVerticalLight: WordmarkSymbolVerticalLightIllustration,
    wordmarkTaglineBoDark: WordmarkTaglineBoDarkIllustration,
    wordmarkTaglineDark: WordmarkTaglineDarkIllustration,
    wordmarkTaglineLight: WordmarkTaglineLightIllustration,
} as const;
